import { overlayScrimOpacity } from 'pages/styles';

export const TMP_PANEL_PARKED_LEFT = '-200%';

/** Show a scrim without a one-frame full paint (display:block while opacity is still high). */
const showOverlayScrim = (bg: HTMLElement) => {
  bg.style.opacity = '0';
  bg.style.display = 'block';
  // Force layout so the opacity transition starts from 0, not a stale value.
  void bg.offsetWidth;
  bg.style.opacity = overlayScrimOpacity;
};

const hideOverlayScrim = (bg: HTMLElement) => {
  bg.style.opacity = '0';
  bg.style.display = 'none';
};

export const moveTmpPanelTmp = (removeOnly: boolean, id: string) => {
  const tmpPanel = document.getElementById(id);
  const bg = document.getElementById(`${id}_bg`);
  if (tmpPanel && bg) {
    const tmpPanelStyle = window.getComputedStyle(tmpPanel);
    const isShowingMenu = tmpPanelStyle.left === '0px';
    if (isShowingMenu) {
      hideOverlayScrim(bg);
      tmpPanel.style.transition = 'all ease-in 250ms';
      tmpPanel.style.left = '0px';
      tmpPanel.style.left = `-${tmpPanelStyle.width}`;
      // After the slide, park far off-screen. Closing to -width only leaves a peek
      // if the panel grows later (search chips / expanded groups).
      window.setTimeout(() => {
        if (!document.getElementById(id)) return;
        if (window.getComputedStyle(tmpPanel).left === '0px') return;
        tmpPanel.style.transition = 'none';
        tmpPanel.style.left = TMP_PANEL_PARKED_LEFT;
      }, 260);
      return;
    }

    if (!removeOnly) {
      showOverlayScrim(bg);
      // Snap beside the viewport first when parked at -200%, then slide in.
      tmpPanel.style.transition = 'none';
      tmpPanel.style.left = `-${tmpPanelStyle.width}`;
      // Force reflow so the open transition starts from -width, not -200%.
      void tmpPanel.offsetWidth;
      tmpPanel.style.transition = 'all ease-out 250ms';
      tmpPanel.style.left = '0px';
    }
  }
};

export const moveTmpPanel = (id?: string, removeOnly?: boolean, _skipSideBar?: boolean) => {
  if (id) {
    moveTmpPanelTmp(removeOnly || false, id);
  } else {
    for (let i = 0; i < 2; i += 1) {
      moveTmpPanelTmp(true, `tmp_panel${i}`);
    }
  }
};

/** Keep sidebar mounted but under in-page overlays (RightPanel stacking context). */
export const setSidebarUnderOverlays = (under: boolean) => {
  const sideBar = document.getElementById('sidebar');
  if (!sideBar) return;
  sideBar.style.zIndex = under ? '1' : '';
};

export const moveSideBar = function moveSideBar(removeOnly?: boolean) {
  const sideBar = document.getElementById('sidebar');
  const bg = document.getElementById('main_bg');
  if (sideBar && bg) {
    const sideBarStyle = window.getComputedStyle(sideBar);
    const isShowingMenu = sideBarStyle.left === '0px';
    if (isShowingMenu) {
      hideOverlayScrim(bg);
      sideBar.style.transition = 'all ease-in 250ms';
      sideBar.style.left = '0px';
      sideBar.style.left = `-${sideBarStyle.width}`;
      return;
    }
    if (!removeOnly) {
      showOverlayScrim(bg);
      sideBar.style.transition = 'all ease-out 250ms';
      sideBar.style.left = `-${sideBarStyle.width}`;
      sideBar.style.left = '0px';
    }
  }
};

/** Open the mobile side drawer if it is off-screen (no-op when already open). */
export const openSideBar = function openSideBar() {
  const sideBar = document.getElementById('sidebar');
  const bg = document.getElementById('main_bg');
  if (!sideBar || !bg) return;
  const sideBarStyle = window.getComputedStyle(sideBar);
  // Desktop LeftPanel has no `left` (auto) — only open the mobile drawer.
  if (sideBarStyle.left === 'auto' || sideBarStyle.left === '0px') return;
  showOverlayScrim(bg);
  sideBar.style.transition = 'all ease-out 250ms';
  sideBar.style.left = `-${sideBarStyle.width}`;
  sideBar.style.left = '0px';
};

export const clearMainBG = () => {
  moveSideBar(true);
  const bg = document.getElementById('main_bg');
  if (bg) {
    hideOverlayScrim(bg);
  }
};
